module.exports = __webpack_public_path__ + "img/Travel.c3290e46.svg";